
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories/all",
      function () {
        return require("private-next-pages/stories/all.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stories/all"])
      });
    }
  